<template>
  <div class="space-between-y">
    <div class="both-sides">
      <el-select @change="getData" clearable v-model="search.type" placeholder="请选择方案类型">
        <el-option v-for="item in option.type" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-button type="primary" @click="handlerEdit()">添加</el-button>
    </div>

    <el-dialog width="300px" :visible.sync="edit.dialog" title="价格方案编辑">
      <miu-vip-plan-save :id="edit.id" v-if="edit.dialog" @saved="planUpdated"></miu-vip-plan-save>
    </el-dialog>

    <el-table v-loading="isLoading" :data="list" stripe border>
      <el-table-column prop="id" label="ID" width="80"></el-table-column>
      <el-table-column prop="name" label="方案名称"></el-table-column>
      <el-table-column prop="vipType" label="VIP类型" width="120">
        <template slot-scope="scope">
          <el-tag type="primary" size="mini" v-if="scope.row.vipType === 'teacher'">教师VIP</el-tag>
          <el-tag type="danger" size="mini" v-if="scope.row.vipType === 'parent'">家长VIP</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="duration" label="时长">
        <template slot-scope="scope">
          {{ scope.row.duration }}天
        </template>
      </el-table-column>
      <el-table-column prop="price" label="价格">
        <template slot-scope="scope">
          {{ scope.row.price }}元
        </template>
      </el-table-column>
      <el-table-column prop="isPromotion" label="是否促销">
        <template slot-scope="scope">
          {{ scope.row.isPromotion ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="60">
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="handlerEdit(scope.row.id)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import {vip} from "@/api/miu/vip";
import MiuVipPlanSave from "@/components/miu/vip/MiuVipPlanSave.vue";

export default {
  name: 'MiuVipPlan',
  components: {MiuVipPlanSave},
  data() {
    return {
      list: [],
      edit: {
        dialog: false,
        id: null
      },

      search: {
        type: null
      },

      isLoading: false,

      option: {
        type: [
          {
            value: 'teacher',
            label: '教师VIP'
          },
          {
            value: 'parent',
            label: '家长VIP'
          }
        ]
      }

    }
  },

  created() {
    this.getData();
    // this.handlerEdit();
  },

  methods: {
    handlerEdit(id) {
      this.edit.id = id;
      this.edit.dialog = true;
    },

    getData() {
      this.isLoading = true;
      vip.plan.list(this.search.type).then(res => {
        this.list = res.data;
        this.isLoading = false;
      })
    },
    planUpdated() {
      this.edit.dialog = false;
      this.edit.id = null;
      this.getData();
    },
  },

}
</script>

<style scoped>

</style>